import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=cab7cbac&scoped=true&"
var script = {}
import style0 from "./Help.vue?vue&type=style&index=0&id=cab7cbac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab7cbac",
  null
  
)

export default component.exports
import {QList,QExpansionItem,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QList,QExpansionItem,QCard,QCardSection})
